export const filterFormId = 'local-pack-filter-form-id';
